import type { EUROPACE_PROCESS_EVENTS_REQUEST_STATUS } from 'cpool-constants';
import { EUROPACE_PROCESS_EVENTS_REQUEST_STATUSES } from 'cpool-constants';
import type { SchemaLoanRequestResolver_GetEuropaceProcessEventsRequestStatus } from 'cpool-tables/backend-resolvers';
import { schemaLoanRequestResolver_GetEuropaceProcessEventsRequestStatus } from 'cpool-tables/backend-resolvers';
import { sleep } from 'cpool-utils';
import type { TFunction } from 'i18next';
import { toast } from 'react-toastify';

import { API_EXTERNAL } from '~/config';
import { fetcher } from '~/queryUtils/useQuery';

export const verifyEuropaceProcessEventsRequestStatus = async ({
    loanRequestId,
    t,
}: {
    loanRequestId: string;
    t: TFunction<'de' | 'en', undefined>;
}) => {
    const RETRIES = API_EXTERNAL.EUROPACE.REQUEST_PROCESS_EVENTS.MAX_RETRIES;
    const waitTime = API_EXTERNAL.EUROPACE.REQUEST_PROCESS_EVENTS.RETRY_INTERVAL;
    try {
        let europaceProcessEventRequestStatus: EUROPACE_PROCESS_EVENTS_REQUEST_STATUS =
            EUROPACE_PROCESS_EVENTS_REQUEST_STATUSES.PENDING;
        let status: SchemaLoanRequestResolver_GetEuropaceProcessEventsRequestStatus = null;
        let counter = 0;
        while (
            europaceProcessEventRequestStatus === EUROPACE_PROCESS_EVENTS_REQUEST_STATUSES.PENDING &&
            counter < RETRIES
        ) {
            // eslint-disable-next-line no-await-in-loop
            await sleep(waitTime);
            // eslint-disable-next-line no-await-in-loop
            status = await fetcher({
                meta: {
                    queryUrl: `/query/loan-request/getEuropaceProcessEventsRequestStatus?id=${loanRequestId}`,
                    schema: schemaLoanRequestResolver_GetEuropaceProcessEventsRequestStatus,
                },
            });
            if (!status) {
                toast.error(t('SIDE_INFO.EXTERNAL_SERVICES.EUROPACE.PROCESS_EVENTS.ERROR_RESPONSE.NOT_FOUND'));
                return;
            }

            if (status) {
                europaceProcessEventRequestStatus = status;
            }
            counter += 1;
        }
        if (europaceProcessEventRequestStatus === EUROPACE_PROCESS_EVENTS_REQUEST_STATUSES.SUCCESS) {
            toast.success(t('SIDE_INFO.EXTERNAL_SERVICES.EUROPACE.PROCESS_EVENTS.ERROR_RESPONSE.SUCCESS'));
        } else if (europaceProcessEventRequestStatus === EUROPACE_PROCESS_EVENTS_REQUEST_STATUSES.FAILED) {
            toast.error(t('SIDE_INFO.EXTERNAL_SERVICES.EUROPACE.PROCESS_EVENTS.ERROR_RESPONSE.FAILED'));
        } else if (europaceProcessEventRequestStatus === EUROPACE_PROCESS_EVENTS_REQUEST_STATUSES.PENDING) {
            toast.info(t('SIDE_INFO.EXTERNAL_SERVICES.EUROPACE.PROCESS_EVENTS.ERROR_RESPONSE.STILL_PENDING'));
        }
    } catch (e) {
        toast.error(t('SIDE_INFO.EXTERNAL_SERVICES.EUROPACE.PROCESS_EVENTS.ERROR_RESPONSE.REQUEST_ERROR'));
    }
};
